/* eslint-disable react/prop-types */
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useModal from "hooks/useModal";
import * as React from "react";
import separate from "utils/separate";
import SoftBadge from "../../components/SoftBadge";
import fixTableCellWidth from "../../utils/fixTableCellWidth";
import TableHeadItems from "./TableHeadItems";
import UpdateGhollakModal from "./UpdateGhollakModal";
import { Checkbox } from "@mui/material";
import { updateGhollak } from "../../services/ghollak.routes";
import queryString from "../../utils/queryString";
import { toast } from "react-toastify";
import { useState } from "react";
import Loading from "../../components/Loading";
import GhollakMoreInfoModal from "./moreInfo/GhollakMoreInfoModal";
import { useNavigate } from "react-router-dom";

function createData(id, initial_balance, name, type_name, balance, locked, operation) {
  return {
    id,
    initial_balance,
    name,
    type_name,
    balance,
    locked,
    operation,
  };
}

function Row(props) {
  const { row, setLoading, setGhollaks } = props;
  const updateGhollakItem = (itemId, event) => {
    let answer = window.confirm("آیا از تغییر وضعیت اطمینان دارید؟");
    if (answer) {
      setLoading(true);
      const query = { locked: +event.target.checked };
      updateGhollak(itemId, queryString(query), (isOk, data) => {
        setLoading(false);
        if (!isOk) {
          return toast.error(data.message);
        } else {
          toast.success("قلک ویرایش شد!");
          setGhollaks(prevGhollaks => prevGhollaks.map(ghollak =>
            ghollak.id === itemId ? { ...ghollak, ...query } : ghollak,
          ));
        }
      });
    }
  };
  return (
    <React.Fragment>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
        <TableCell className="tablecell" align="left" title={row.name}
                   style={fixTableCellWidth("160px")}>{row.name}</TableCell>
        <TableCell className="tablecell" align="left" title={separate(Number(row.initial_balance))}
                   style={fixTableCellWidth("160px")}>{separate(Number(row.initial_balance))}</TableCell>
        <TableCell className="tablecell" align="left" title={separate(Number(row.balance))}
                   style={fixTableCellWidth("160px")}>{separate(Number(row.balance))}</TableCell>
        <TableCell className="tablecell" align="left" title={row.type_name}
                   style={fixTableCellWidth("160px")}>{row.type_name}</TableCell>
        <TableCell className="tablecell" align="left"
                   style={fixTableCellWidth("110px")}><Checkbox checked={row.locked}
                                                                onChange={(event) => updateGhollakItem(row.id, event)}
        /></TableCell>
        <TableCell className="tablecell" align="left"
                   style={fixTableCellWidth("200px")}>{row.operation}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function GhollakTable({ data, setGhollaks, filterInfo, handleFilterChange,onFilterClick }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const [modals, updateModal, closeModal] = useModal({
    updateGhollak: { state: false },
    ghollakMoreInfo: { state: false },
  });
  const closeUpdateGhollakModal = () => closeModal("updateGhollak");
  const closeGhollakMoreInfoModal = () => closeModal("ghollakMoreInfo");

  const rows = data.map(item => createData(item.id, item.initial_balance, item.name, item.type_name, item.balance, item.locked,
    <section style={{ display: "flex", cursor: "pointer" }}>
      <SoftBadge variant="contained"
                 onClick={() => updateModal("ghollakMoreInfo", { state: true, item })}
                 badgeContent="اطلاعات بیشتر"
                 color="success" size="xs" />
      <SoftBadge variant="contained"
                 onClick={() => navigate(`/qrcode?ghollak_id=${item.id}`)}
                 badgeContent="کیوآر"
                 color="primary" size="xs" />
      <SoftBadge variant="contained"
                 onClick={() => updateModal("updateGhollak", { state: true, item })}
                 badgeContent="آپدیت"
                 color="secondary" size="xs" />
    </section>,
  ));

  return (
    <>
      <Loading loading={loading} />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableHeadItems filterInfo={filterInfo} onFilterClick={onFilterClick} handleFilterChange={handleFilterChange} />
            <TableRow>
              <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نام</TableCell>
              <TableCell className="tablecell" style={fixTableCellWidth("150px")}>موجودی اولیه</TableCell>
              <TableCell className="tablecell" style={fixTableCellWidth("170px")}>موجودی</TableCell>
              <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نوع</TableCell>
              <TableCell className="tablecell" style={fixTableCellWidth("110px")}>آیا قفل است</TableCell>
              <TableCell className="tablecell" style={fixTableCellWidth("200px")}>عملیات ها</TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{ display: "block" }}>
            {rows.map((row) => (
              <Row key={row.id} row={row} setLoading={setLoading} setGhollaks={setGhollaks} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {modals.updateGhollak.state && <UpdateGhollakModal modalInfo={modals.updateGhollak} setGhollaks={setGhollaks}
                                                         closeModal={closeUpdateGhollakModal} />}
      {modals.ghollakMoreInfo.state && <GhollakMoreInfoModal modalInfo={modals.ghollakMoreInfo}
                                                             closeModal={closeGhollakMoreInfoModal} />}
    </>
  );
}
